import { createAll } from '@/api/gabed/bonStock';
import i18n from '@/i18n/index';
import { columns } from '@/services/import/bonStock/templateBonStock';
import store from '@/store/store';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import genererBonStock from '@/services/import/bonStock/genererBonStock';

export function ErrorBonStockTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];

  return errors.map(error => {
    if (error.endsWith('_CLIENT_NOT_FOUND')) {
      return i18n.t('importationBonStock.errors.clientNotFound', { reference: error.split('_')[0] });
    }
    if (error.endsWith('Client_IS_REQUIRED')) {
      return i18n.t('importationBonStock.errors.requiredPropertie', { label: 'Reference Externe' });
    }
    if (error.endsWith('_CLIENT_NOT_LIEU_DE_STOCKAGE')) {
      return i18n.t('importationBonStock.errors.clientIsNotLieuDeStockage', { reference: error.split('_')[0] });
    }
    switch (error) {
      case 'SOCIETE_HAS_NO_VENTE_STOCK_PRODUCT':
        return i18n.t('importationBonStock.errors.noDefaultProductForVenteStock');
      case 'SOCIETE_HAS_NO_ACHAT_STOCK_PRODUCT':
        return i18n.t('importationBonStock.errors.noDefaultProductForAchatStock');
      default:
        break;
    }
    return 'Problème Survenu';
  }).join(' - ');
}

function validationSociete(lignes, societe, errors) {
  if (lignes.some(ligne => {
    return ligne.soldeBache && Number.isInteger(+ligne.soldeBache) && +ligne.soldeBache > 0;
  })) {
    if (!societe.produitVenteBonStockId) {
      errors.push({ general: ['SOCIETE_HAS_NO_VENTE_STOCK_PRODUCT'] });
    }
  }
  if (lignes.some(ligne => {
    return ligne.soldeBache && Number.isInteger(+ligne.soldeBache) && +ligne.soldeBache < 0;
  })) {
    if (!societe.produitVenteBonStockId) {
      errors.push({ general: ['SOCIETE_HAS_NO_ACHAT_STOCK_PRODUCT'] });
    }
  }
}
function validationLigne(ligne, tiers, errors) {
  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) {
      columnErrors.forEach(error => {
        errors.push({ errors: [error], numLigne: ligne.numLigne });
      });
    }
  });
  if (!tiers && ligne.refExterneTiers) {
    errors.push({ errors: [`${ligne.refExterneTiers}_CLIENT_NOT_FOUND`], numLigne: ligne.numLigne });
  }
  if (tiers && !tiers.lieuStockage) {
    errors.push({ errors: [`${ligne.refExterneTiers}_CLIENT_NOT_LIEU_DE_STOCKAGE`], numLigne: ligne.numLigne });
  }
}

export async function makeBonStockGenerated(file) {
  const bonStocks = [];
  const data = [];
  const errors = [];
  const societeActive = store.getters['societe/societeActive'];

  for (let i = 1; i < file[0].length; i += 1) {
    const ligne = file[0][i];
    data.push(ligne);
  }

  const referenceExterne = data.map(ligne => ligne.refExterneTiers)
    .filter((value, index, self) => self.indexOf(value) === index)
    .filter(value => !!value);
  const tiers = referenceExterne.length > 0 ? (await getAllTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      type: TIERS_TYPE_CLIENT,
      referencesExterne: referenceExterne,
    },
    limit: NO_PAGINATION,
  })).data.result.items : [];
  validationSociete(data, societeActive, errors);
  for (let i = 0; i < data.length; i += 1) {
    const client = tiers.find(client => client.referenceExterne === data[i].refExterneTiers);
    validationLigne(data[i], client, errors);
    if (data[i].soldeBache !== undefined && +data[i].soldeBache !== 0) {
      const newBon = genererBonStock(data[i], client, societeActive);
      bonStocks.push(newBon);
    }
  }
  if (errors.length > 0) throw errors;
  return bonStocks;
}

export async function makeBonStockImport(data, modeTest) {
  await createAll(data, modeTest);
}
